import { render, staticRenderFns } from "./SolicitudVehiculoForm.vue?vue&type=template&id=6b56f9f0"
import script from "./SolicitudVehiculoForm.vue?vue&type=script&lang=js"
export * from "./SolicitudVehiculoForm.vue?vue&type=script&lang=js"
import style0 from "./SolicitudVehiculoForm.vue?vue&type=style&index=0&id=6b56f9f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports